// Sort options + sort-key -> GraphQL `order` mapping for the Share feeds
// (Discover + Meine Beiträge). Kept out of the pill component so Fast Refresh
// stays happy (a .tsx exporting both a component and constants warns).

import { SortOrder, type SharedItemSortInput } from "@/graphql/generated/operations";

export const SORT_OPTIONS = [
  { id: "new", labelId: "sort.new" },
  { id: "old", labelId: "sort.old" },
  { id: "top", labelId: "sort.top" },
  { id: "az", labelId: "sort.az" },
] as const;

export type SortKey = (typeof SORT_OPTIONS)[number]["id"];

const ORDERS: Record<SortKey | "interest" | "discussed", SharedItemSortInput> = {
  new: { publishedOn: SortOrder.Desc },
  old: { publishedOn: SortOrder.Asc },
  top: { rating: SortOrder.Desc },
  az: { name: SortOrder.Asc },
  interest: { signUps: SortOrder.Desc },
  discussed: { comments: SortOrder.Desc },
};

export function sortOrderFor(key: keyof typeof ORDERS): SharedItemSortInput {
  return ORDERS[key];
}
